import { useEffect, useState } from "react";
import { safeFetch } from "@/api/safeFetch";

export const useBackendHealth = () => {
  const [isBackendOnline, setIsBackendOnline] = useState(true);

  useEffect(() => {
    let delay = 5000;
    let timeout: ReturnType<typeof setTimeout>;

    const check = async () => {
      try {
        const res = await safeFetch("/api/ping", { cache: "no-store" });

        if (res.ok) {
          setIsBackendOnline(true);
          delay = 5000; // reset
        } else {
          setIsBackendOnline(false);
          delay = Math.min(delay * 1.5, 30000);
        }
      } catch (err: any) {
        const isNetworkError =
          err instanceof TypeError ||
          err?.message?.includes("Failed to fetch");

        if (isNetworkError) {
          setIsBackendOnline(false);
        }

        delay = Math.min(delay * 1.5, 30000);
      }

      timeout = setTimeout(check, delay);
    };

    check();

    return () => clearTimeout(timeout);
  }, []);

  return isBackendOnline;
};